export default function alignProduct() {
  const statusBlockElems = document.querySelectorAll('.js-product-thumb-status-block');

  if (!statusBlockElems.length) return;

  function changeAlignment() {
    const isXS = window.matchMedia('only screen and (max-width: 599px)').matches;
    const isFromXStoSM = window.matchMedia('only screen and (min-width: 600px) and (max-width: 767px)').matches;

    if (isXS) {
      for (let i = 0; i < statusBlockElems.length; i++) {
        if (i % 2 === 0) {
          const firstElem = statusBlockElems[i];
          const secondElem = statusBlockElems[i + 1];

          if (!secondElem) return;

          firstElem.style.minHeight = '';
          secondElem.style.minHeight = '';

          // eslint-disable-next-line func-names
          setTimeout(function() {
            const maxHeight =
              Math.max(
                parseInt(getComputedStyle(firstElem).height, 10),
                parseInt(getComputedStyle(secondElem).height, 10)
              );

            firstElem.style.minHeight = `${maxHeight}px`;
            secondElem.style.minHeight = `${maxHeight}px`;
          })
        }
      }
    } else if (isFromXStoSM) {
      for (let i = 0; i < statusBlockElems.length; i++) {
        if ((i + 3) % 3 === 0) {
          const firstElem = statusBlockElems[i];
          const secondElem = statusBlockElems[i + 1];
          const thirdElem = statusBlockElems[i + 2];

          if (firstElem) firstElem.style.minHeight = '';
          if (secondElem) secondElem.style.minHeight = '';
          if (thirdElem) thirdElem.style.minHeight = '';

          // eslint-disable-next-line func-names
          setTimeout(function() {
            const firstElemHeight = firstElem ? getComputedStyle(firstElem).height : 0
            const secondElemHeight = secondElem ? getComputedStyle(secondElem).height : 0
            const thirdElemHeight = thirdElem ? getComputedStyle(thirdElem).height : 0

            const maxHeight =
              Math.max(
                parseInt(firstElemHeight, 10),
                parseInt(secondElemHeight, 10),
                parseInt(thirdElemHeight, 10)
              );

            if (firstElem) firstElem.style.minHeight = `${maxHeight}px`;
            if (secondElem) secondElem.style.minHeight = `${maxHeight}px`;
            if (thirdElem) thirdElem.style.minHeight = `${maxHeight}px`;
          })
        }
      }
    } else {
      for (let i = 0; i < statusBlockElems.length; i++) {
        statusBlockElems[i].style.minHeight = '';
      }
    }
  }

  changeAlignment();

  window.addEventListener('resize', changeAlignment);
}